import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { BILLING_RUN_TYPE } from 'src/features/billingRuns/utils/types';
import {
    BillingAttempt,
    BILLING_ATTEMPT_ERROR_CODE,
    BILLING_ATTEMPT_STATUS,
} from 'src/features/billingAttempts/utils/types';

const RESOURCE = '/charges/billing-attempt/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    type?: BILLING_RUN_TYPE[];
    status?: BILLING_ATTEMPT_STATUS[];
    error_code?: BILLING_ATTEMPT_ERROR_CODE[];
    billing_run?: string[];
    subscription?: string[];
    subscription_item?: string[];
    customer?: string[];
    billing_period_start_after?: string;
    billing_period_start_before?: string;
    created_at_after?: string;
    created_at_before?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<BillingAttempt>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_BILLING_ATTEMPTS_RESOURCE, useQueryHook as useListBillingAttempts };
